





















import { defineComponent } from '@vue/composition-api'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'

export default defineComponent({
  name: 'SortProductsList',
  data() {
    return {
      sortDirection: 'asc',
      sortFieldName: 'id',
    }
  },
  methods: {
    setSortDirection(event: string) {
      this.sortDirection = event
      ProductsFromCatalogStore.commit('setSortByDirection', this.sortDirection)
    },
    setSortField(event: string) {
      this.sortFieldName = event
      ProductsFromCatalogStore.commit('setSortByField', this.sortFieldName)
    },
  },
})
